import { useState } from "react";

function useLocalStorage(key, initialValue) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);

      // Parse stored json or if none return initialValue
      return item ? JSON?.parse(item) : initialValue;
    } catch (err) {
      // If error also return initialValue
      console.log("Error in local storage : ", err);

      return initialValue;
    }
  });

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.

  const setValue = (value) => {
    try {
      const valueToStore =
        typeof value === "function" ? value(storedValue) : value;

      setStoredValue(valueToStore);

      window.localStorage.setItem(key, JSON?.stringify(valueToStore));
    } catch (err) {
      console.log("Error in set function : ", err);
    }
  };

  return [storedValue, setValue];
}

export default useLocalStorage;
